import { useAirModal } from '@air/provider-modal';

import { OutOfStorageModal } from '~/components/Modals/OutOfStorageModal';
import { useCanConsumeMoreCredits } from '~/hooks/useCanConsumeMoreCredits';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';
import { useStorage } from '~/swr-hooks/subscriptions/useStorage';
import { canViewSubscription } from '~/utils/permissions/workspacePermissions';

export const useStoragePlanRestriction = () => {
  const { data: storage } = useStorage();
  const { canConsumeMoreCredits, showCreditsDepletedModal } = useCanConsumeMoreCredits();
  const { data: permissions } = useCurrentWorkspacePermissionsContext();
  const { data: subscription } = useSubscriptionContext();
  const [showOutOfStorageModal] = useAirModal(OutOfStorageModal);

  const canSeeSubscription = canViewSubscription(permissions);

  if (!canSeeSubscription) {
    return {
      isStoragePlanRestricted: false,
      showStoragePlanRestrictionModal: () => {},
    };
  }

  // Storage only costs credits on credit-model plans, so only they stop uploads when credits run out.
  if (subscription?.isCreditModel && !canConsumeMoreCredits) {
    return {
      isStoragePlanRestricted: true,
      showStoragePlanRestrictionModal: showCreditsDepletedModal,
    };
  }

  return {
    isStoragePlanRestricted: storage?.isOutOfStorage === true,
    showStoragePlanRestrictionModal: showOutOfStorageModal,
  };
};
